// extracted by mini-css-extract-plugin
export default {"map":"project_map__7IHnP","title":"project_title__ISIzB","subtitle":"project_subtitle__Vzjrg","description":"project_description__Z6dVQ","video":"project_video__EmlLW"};